import { useMemo } from "react";

import { PlayingSurface, useGetAllPlayingSurfacesQuery } from "../../../redux/slices";
import { SportPlay } from "../../../types";
import { TSelectItem, useSelect } from "../../select";
import { UseSelect } from "../types";

export type SelectPlayingSurfaceItem = TSelectItem<PlayingSurface>;

export const useSelectPlayingSurface = <TPlay extends SportPlay>({ editingPlay, updatePlay }: UseSelect<TPlay>) => {
  const { data: playingSurfaces } = useGetAllPlayingSurfacesQuery();

  const playingSurfaceItems: SelectPlayingSurfaceItem[] = useMemo(
    (): SelectPlayingSurfaceItem[] => playingSurfaces?.map((ps) => ({ ...ps, label: ps.description })) || [],
    [playingSurfaces]
  );

  const selectedPlayingSurface = useMemo(
    () => playingSurfaceItems.find((ps) => ps.description === editingPlay.playSurfaceId),
    [editingPlay, playingSurfaceItems]
  );

  const handleChangePlayingSurface = (item: SelectPlayingSurfaceItem) => {
    updatePlay((prevValue) => ({ ...prevValue, playSurfaceId: item.description }));
  };

  const playingSurfaceSelect = useSelect({
    items: playingSurfaceItems,
    initialSelectedItem: selectedPlayingSurface,
    onChange: handleChangePlayingSurface,
  });

  return { playingSurfaceSelect };
};
